<template>
    <div>
      <header>
        <h1>Apartment Management</h1>
        <select v-model="selectedApartmentId" @change="fetchApartmentData">
          <option v-for="apartment in apartments" :key="apartment.id" :value="apartment.id">
            {{ apartment.name }}
          </option>
        </select>
        <nav>
          <router-link to="/manage">Dashboard</router-link>
          <router-link to="/manage/rooms">Rooms</router-link>
          <router-link to="/manage/invoices">Invoices</router-link>
          <router-link to="/manage/users">Users</router-link>
        </nav>
      </header>
      <main>
        <router-view></router-view>
      </main>
    </div>
  </template>

  <script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'ApartmentsManagement',
    data() {
      return {
        selectedApartmentId: null,
      };
    },
    computed: {
      ...mapState(['apartments']),
    },
    created() {
      const storedApartmentId = sessionStorage.getItem('selectedApartmentId');
      if (storedApartmentId) {
        this.selectedApartmentId = storedApartmentId;
        this.fetchApartmentData();
      }
    },
    methods: {
      ...mapActions(['fetchUserRelationships']),
      fetchApartmentData() {
        if (this.selectedApartmentId) {
          this.fetchUserRelationships(this.selectedApartmentId);
        }
      },
    },
  };
  </script>
